import { withTableView } from '@components/enitity/table/Table.view'
import { OffersTable } from '@features/offers'
import { useTranslation } from 'react-i18next'

export const Offers = () => {
  const { t } = useTranslation('offers')

  const TableWithView = withTableView(OffersTable, t('title'))

  return <TableWithView />
}
